import React from 'react'
import axios from 'axios'
import { axiosConfig } from '../plugins/utils/ascUtils'

// linkType options:
const iconMapping = {
    factsheets: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/factsheets.png',
    website: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/website.png',
    easyread: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/rightarrow.svg',
}

export function showQuickLink(sender_id, payload, link, linkType, dataset) {
    const { buttons_bg_color, buttons_text_color } = dataset

    async function handleLogClick() {
        const jsonBodyData = {
            message: `${linkType} | ${link}`,
            payload: payload,
            sender: sender_id,
            msg_type: 'log_click',
        }
        await axios.post(
            `https://asc-saas-action-server-prod.azurewebsites.net/webhook`,
            jsonBodyData,
            axiosConfig
        )
    }

    if (link && linkType) {
        return (
            <div className='quick-link-holder'>
                <a
                    href={`${link}`}
                    target='_blank'
                    rel='noreferrer'
                    onClick={handleLogClick}
                >
                    <div
                        className='quick-link-button'
                        style={{
                            backgroundColor: buttons_bg_color,
                            color: buttons_text_color,
                        }}
                    >
                        <div className='quick-link-text'>{`${linkType}`}</div>
                        {iconMapping[`${linkType}`] && (
                            <img
                                src={iconMapping[`${linkType}`]}
                                alt={`${linkType}`}
                            />
                        )}
                    </div>
                </a>
            </div>
        )
    }
}
